import React from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '@fiverr-private/visuals';

interface CollapsibleIconProps {
    isCollapse: boolean;
}

export const CollapsibleIcon = ({ isCollapse }: CollapsibleIconProps) =>
    isCollapse ? <ChevronDownIcon size="sm" /> : <ChevronUpIcon size="sm" />;
